module.exports = __webpack_public_path__ + "assets/img/ea77b1b607532971ff346f01a5711b03.png";